import { css } from '@emotion/react'
import {
  Color,
  FocusIndicator,
  Shadow,
  ShadowElevation,
  Size,
  Spacing,
  Typography,
  ZIndex,
} from '@opallabs/gem'

export const dropdownMenu = css({
  color: Color.light['Text/Primary'],
  background: Color.light['Color/Surface/Surface-1'],
  border: `1px solid ${Color.light['Strokes/Secondary-1']}`,
  borderRadius: Size.Rounding * 3,
  boxShadow: Shadow[ShadowElevation.E2].boxShadow,
  display: 'flex',
  flexDirection: 'column',
  gap: Spacing.XS,
  overflow: 'auto',
  padding: `${Spacing.S}px ${Spacing.S}px`,
  position: 'relative',
  zIndex: ZIndex.Shroud.Popover,
  inlineSize: 'max-content',
})

export const item = (selected: boolean) =>
  css({
    justifyContent: 'flex-start',
    ...(selected ? FocusIndicator.light : {}),
  })

export const emptySuggestion = css({
  ...Typography.T500,
  padding: `${Spacing.XS}px`,
  textAlign: 'start',
  maxInlineSize: '250px',
})
